import { StringConstantsMixin } from 'react_components/mixins/shared/string_constants_mixin';
import { US } from 'constants/CountryCode';
import { logGearGlobalHeaderClicked, logGiveProGlobalHeaderClicked } from '@alltrails/analytics/amplitudeFunctions';

const { ALLTRAILS_GEAR, GIVE_PRO, SHOP } = StringConstantsMixin.strings;

const GIVE_PRO_LINK = {
  label: GIVE_PRO,
  linkPath: '/gift?ref=header', // automatically replaced in SideDrawer with mobile-header
  onClick: logGiveProGlobalHeaderClicked
};

export function getShopLink(ipCountryCode) {
  if (ipCountryCode === US) {
    return {
      label: SHOP,
      dropdown: [
        {
          label: ALLTRAILS_GEAR,
          linkPath: 'https://shop.alltrails.com/',
          onClick: () => logGearGlobalHeaderClicked,
          openInNewWindow: true
        },
        GIVE_PRO_LINK
      ]
    };
  }

  return GIVE_PRO_LINK;
}
